import { IReplyAddress } from "store/entities/reply-addresses/interfaces";

import { BaseApi } from "../base";

export class ReplyAddressApi extends BaseApi {
  protected readonly prefix = "replyAddresses";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = (payload: { prefix?: string; emailDomainID?: string }) => this.get("", payload);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (address: Partial<IReplyAddress>) => this.post("", address);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  destroy = (id: string) => this.delete(id);
}
